import React from 'react'
import { useSplitClient } from 'contrastBase/state'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { compose } from '../../../util'
import { injectIntl } from 'react-intl'

const RemoteLibrariesPage = React.lazy(
  // @ts-ignore
  () => import('platformRepositories/LibrariesPage')
)

export const LibrariesMfe = () => {
  const { isSplitTreatmentOn } = useSplitClient()
  const showLibrariesRemote = isSplitTreatmentOn('SCA-1252-libraries-mfe')

  if (!showLibrariesRemote) {
    // Redirect to libraries page when not authorized
    window.location.replace(
      window.location.href.replace('libraries-mfe', 'libraries')
    )
  }

  return showLibrariesRemote ? <RemoteLibrariesPage /> : null
}

export const reactLibrariesMfe = createNgReactBridgeDirective(
  'reactLibrariesMfe',
  [],
  compose(injectIntl)(LibrariesMfe),
  []
)
